import { AsyncPipe, CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject } from '@angular/core';
import { CarouselBannerComponent } from '@components/carousel/carousel-banner/carousel-banner.component';
import { CarouselCategoriesComponent } from '@components/carousel/carousel-categories/carousel-categories.component';
import { CarouselNutridayAdminComponent } from '@components/carousel/carousel-nutriday-admin/carousel-nutriday-admin.component';
import { CarouselNutridayshopComponent } from '@components/carousel/carousel-nutridayshop/carousel-nutridayshop.component';
import { CarouselProductComponent } from '@components/carousel/carousel-product/carousel-product.component';
import { FlashSaleIconComponent } from '@components/icon/flash-sale-icon/flash-sale-icon.component';
import { IntersectObservableComponent } from '@components/intersect-observable/intersect-observable.component';
import { MainLayoutComponent } from '@components/layout/main-layout/main-layout.component';
import { CarouselProductSkeletonComponent } from '@components/skeletons/carousel-product-skeleton/carousel-product-skeleton.component';
import { TemplateMarkerDirective } from '@directives/template-marker.directive';
import { ProductQueryType } from '@models/product.model';
import { PERMISSIONS } from '@models/users.model';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'market-home',
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    CommonModule,
    CarouselProductComponent,
    CarouselBannerComponent,
    MainLayoutComponent,
    CarouselProductSkeletonComponent,
    IntersectObservableComponent,
    TemplateMarkerDirective,
    CarouselCategoriesComponent,
    CarouselNutridayshopComponent,
    FlashSaleIconComponent,
    CarouselNutridayAdminComponent,
    AsyncPipe,
  ],
})
export class HomeComponent implements AfterViewInit {
  readonly PRODUCT_TYPE = ProductQueryType;
  isShop = inject(AuthService).userInfo().role === PERMISSIONS.shop;

  bannerHeight = `${Math.min(window.screen.width, 480)}px`;

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
  }
}
